import React, { useEffect, useState } from "react";
import { getListProvince } from "src/apis/ADB/province.api";
import Controls from "src/components/form/controls/Controls";
import useForm, { Form } from "src/hooks/useForm";
import { validationADBDistrictInput } from "src/pages/AdministrativeBoundaries/utils/validateInput";
import { notContainsOnlySpaces } from "src/utils";

const initialValue = {
  id: "",
  districtName: "",
  districtCode: 0,
  provinceId: "",
};

function DistrictForm(props) {
  const { addOrEdit, recordForEdit } = props;

  // list province
  const [listProvince, setListProvince] = useState([]);

  // validation input permission
  const validateADBDistrictForm = (fieldValues = values) => {
    let temp = validationADBDistrictInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateADBDistrictForm);

  const onSubmit = (e) => {
    e.preventDefault();

    if (validateADBDistrictForm()) {
      addOrEdit(values, resetForm);
    }
  };

  useEffect(() => {
    getListProvince((result) => {
      setListProvince([...result]);
    });
  }, []);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="districtName"
        value={values.districtName}
        label="District Name"
        type="text"
        onChange={handleInputChange}
        error={errors.districtName}
      />
      <Controls.Input
        name="districtCode"
        value={values.districtCode}
        label="District Code"
        type="number"
        disabled={Boolean(recordForEdit)}
        onChange={handleInputChange}
        error={errors.districtCode}
      />

      <Controls.AdministrativeSelect
        name="provinceId"
        label="Provinces"
        value={values.provinceId}
        onChange={handleInputChange}
        options={listProvince}
        optionField={{ key: "id", value: "provinceName" }}
        error={errors.provinceId}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={notContainsOnlySpaces(values.districtName) ? false : true}
      />
    </Form>
  );
}

export default DistrictForm;
